import {deviceService} from 'interactors/deviceProxy';
import {stateToWidget} from '../stateToWidget';

interface UpdateWidgetDependencies {
  service?: DeviceService;
}

export function updateWidget(settings: CoreState, di: UpdateWidgetDependencies = {}): void {
  const {service = deviceService} = di;
  service.updateWidget(stateToWidget(settings));
}
